import { useMutation } from "@tanstack/react-query";
import {
  photoSeriesAdd,
  PhotoSeriesAddParams,
} from "common/api/citajteo/photo_series/photo_series";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UsePhotoSeriesAddParams = {
  invalidateKeys?: string[];
  successHandle?: Function;
  errorHandle?: Function;
};

export const usePhotoSeriesAdd = (hookParams?: UsePhotoSeriesAddParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: photoSeriesAddMutate } = useMutation({
    mutationFn: async (photoSeriesAddParams: PhotoSeriesAddParams) => {
      const response = await photoSeriesAdd(photoSeriesAddParams);

      if (response === null) {
        throw new Error("photoSeriesAdd failed");
      }

      return response;
    },
    onSuccess: (response) => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }

      if (hookParams?.successHandle) {
        hookParams.successHandle(response);
      }
    },
    onError: (error) => {
      if (hookParams?.errorHandle) {
        hookParams.errorHandle(error);
      }
    },
  });

  return { photoSeriesAddMutate };
};
